<h3 matDialogTitle>Scanned document detected</h3>
<button class="close-btn" mat-icon-button matDialogClose>
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  @if (fileName) {
    <p class="file-name">
      <mat-icon>description</mat-icon>
      <span>{{ fileName }}</span>
    </p>
  }

  <div class="warning">
    <mat-icon class="warning__icon">warning_amber</mat-icon>
    <p class="warning__message">
      This document appears to be scanned. For best results, please upload a
      true digital PDF. You can also fill out the deal manually if a digital
      version is not available.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="fillOutManually()">Fill out manually</button>
  <button mat-button class="qt-dialog-primary-button" (click)="uploadDigital()">
    Upload a digital PDF
  </button>
</mat-dialog-actions>
